import { useEffect } from 'react'
import seqStore from '../../store/seqStore'

export default function Division() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const division = seqStore((state) => state.settings.division)
    const setDivision = seqStore((state) => state.setDivision)

    const divisionArray = ['1', '2', '4', '8', '16', '32', '64']

    // DIVISION CONTROLS
    const handleDivision = (e) => {
        const value = e.target.value
        setDivision(currentTrack, Number(value))
    }

    const resetDivision = () => {
        setDivision(currentTrack, 4)
    }
    
    return (
        <div id='divisionInput'>
            <label htmlFor="root note"><p>Division <span>{divisionArray[division[currentTrack]]}</span></p></label>
            <input id='enabledInput' type="range" min={0} max={6} step='1' value={division[currentTrack]} onChange={e => handleDivision(e)} onDoubleClick={resetDivision}/>
        </div>
    )
}
